import React from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import { usePresettlementExclusionsHook } from "../../PresettlementExclusionsTable/usePresettlementExclusionsHook";
import { DateSelect } from "Components/Shared/DateSelect/DateSelect";

export interface PayDateSelectProps {
  selectedPayDate: string;
  expectedDates: string[];
}

export const PayDateSelect = ({ selectedPayDate, expectedDates }: PayDateSelectProps) => {
  const classes = useStyles();
  const { onPayDateChange } = usePresettlementExclusionsHook();

  return (
    <Grid item xs={4} container alignItems="center" justify="flex-start">
      <Grid item xs={3}>
        Pay Date
      </Grid>
      <Grid item xs={9} className={classes.select}>
        <DateSelect
          date={selectedPayDate}
          onChangeDate={onPayDateChange}
          dates={expectedDates}
        />
      </Grid>
    </Grid>
  );
};
